
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataUtils } from 'app/core/util/data-util.service';
import { Component, OnInit } from '@angular/core';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { CbicContentTypeMstService } from 'app/entities/cbic-content-type-mst/service/cbic-content-type-mst.service';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { SessionStorageService } from 'ngx-webstorage';
import { UtilsService } from 'app/core/util/view-file.component';
import { getMatScrollStrategyAlreadyAttachedError } from '@angular/cdk/overlay/scroll/scroll-strategy';
import { ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'cbic-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  url:any;
  solrData:any;
  param:any;
  page=1;
  isDisabled = true;
  myParam: any;
  Pageing = 0;
  pageSize: any;
  tableSize = 10;
  tableSizes = [10, 15, 20, 25, 50, 100, 200, 300, 400, 500]
  count = 0;


    constructor(private sessionStorageService: SessionStorageService,private contentMstService : CbicContentMstService,private cbicContentTypeMstService :CbicContentTypeMstService,private changeLnService: ChangeLanguageService, private cbicDocMstService: CbicDocMstService
    ,private http: HttpClient,  private dataUtils: DataUtils, public utils: UtilsService, private route: ActivatedRoute){}
  // ngOnInit(): void {
  //   throw new Error('Method not implemented.');
  // }

  //constructor( public utils: UtilsService) { }

  ngOnInit(): void {
    // this.getSolrData('customs'); 
    // this.route.params.subscribe(params:Params )=> {this.myParam = Params['serachText']} );
    this.route.params.subscribe(
      (params: Params) => {
        this.myParam = params["serachText"];
        // console.log(this.myParam);
        this.getSolrData(this.myParam, 0, 100000000000000000);

      }
    );
    
 
  
    // alert(this.solrData); 
    // throw new Error('Method not implemented.');

    
  }
  toggleDisabled() {
		this.isDisabled = !this.isDisabled;
	}

  getSolrData(serachkeyWord:any,Pageing: number, pageSize: number){
       
 
    this.url="api/search/data-solr".concat("?").concat("serachText=").concat(serachkeyWord);

    console.log(this.url);
    // alert(this.url);
    const response=this.http.get(this.url)
    ;
    response.subscribe((data: any)=>{
    this.solrData=data
    console.log( this.solrData);
  });

 

}
onTableDataChange(page: any) {
  // const request: any = {};
  this.Pageing = page.pageIndex.toString();
  this.pageSize = page.pageSize.toString();
  this.getSolrData(this.solrData, this.Pageing, this.pageSize);
}

ontableSizeChange(event: any): void {
  this.tableSize = event.target.value;
  this.page = 1;
  const request: any = {};
  this.Pageing = event.pageIndex.toString();
  request['size'] = event.pageSize.toString();
  this.getSolrData(this.solrData, this.Pageing, this.pageSize);
}

ViewPdf(filePath: any) {
  this.utils.viewOpenning(filePath);
}

}
